import React from "react";
import { BankAccount } from "domain/payload/response/bankamar/BankAccountResp";

interface Props {
  item: BankAccount;
  onClose: () => void;
}

const BankAccountDetailModal: React.FC<Props> = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Account Detail</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><b>ID:</b> {item.id}</p>
            <p><b>Email:</b> {item.partnerCustomerEmail}</p>
            <p><b>Account Number:</b> {item.accountNumber}</p>
            <p><b>Status:</b> {item.status}</p>
            <p><b>Type:</b> {item.type}</p>
            <p><b>Timestamp:</b> {item.timestamp}</p>

            <hr />
            <h6>Reject Reasons</h6>
            {item.rejectReason && item.rejectReason.length > 0 ? (
              <ul>
                {item.rejectReason.map((r) => (
                  <li key={r.code}>
                    <b>{r.name}</b> – {r.description}
                  </li>
                ))}
              </ul>
            ) : (
              <p>None</p>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankAccountDetailModal;